import { styled as o } from "styled-components";
import { Theme as e } from "../../styles/themes/index.js";
import { Colors as r } from "../../styles/colors/index.js";
import { SmallHeavy as t } from "../../styles/typography/index.js";
const a = o.div`
  ${t}
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background: rgba(${r.Alien}, 0.1);
  color: rgb(${r.Green});
  border-radius: 18px;
  border: 1px solid rgb(${e.colors.Delta});
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: max-content;

  i {
    color: rgb(${r.Green});
    font-size: 24px;
  }
`;
export {
  a as Container
};
